import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { ReactComponent as BtnSVG } from "../../assets/images/bearExplanation/btn.svg";
import "./bearSelection.sass";
import { updateStatus } from "../../actions/userActions";
import ImageSlider from "./ImageSlider";
import bear01 from "../../assets/images/bearSelection/bear01.png";
import bear02 from "../../assets/images/bearSelection/bear02.png";
import bear03 from "../../assets/images/bearSelection/bear03.png";
import bear04 from "../../assets/images/bearSelection/bear04.png";
import BearHover from "../../assets/images/bearSelection/bear_hover.png";
import btn from "../../assets/images/bearSelection/btn.png";
import btnArrow from "../../assets/images/bearSelection/btn_arrow.png";
import btnDisable from "../../assets/images/bearSelection/btn_disable.png";
import btnArrowDisable from "../../assets/images/bearSelection/btn_arrow_disable.png";
import bearImage from "./bearImage";
import usePage from "../../hooks/usePage";

export default function BearSelection() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const statusData = useSelector((state) => state.user.statusData);
  const [selected, setSelected] = useState(null);
  const [isAnimation, setIsAnimation] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [bearName, setBearName] = useState("");
  const [showModal, setShowModal] = useState(false);
  usePage({});

  const bear = [
    { bear: bearImage.bearPink },
    { bear: bearImage.bearYellow },
    { bear: bearImage.bearBlue },
    { bear: bearImage.bearGreen },
  ];

  const bearList = [bear01, bear02, bear03, bear04];

  // 注意這裏返回一個函數
  const selectedHandler = (index) => {
    setSelected(index);
  };

  const handleChange = (event) => {
    const input = event.target.value;
    let length = 0;

    // 計算字元長度，中文算作2，英文算作1
    for (let i = 0; i < input.length; i++) {
      if (input.charCodeAt(i) > 127 || input.charCodeAt(i) === 94) {
        length += 2;
      } else {
        length += 1;
      }
    }

    // 判斷是否超過限制（中文字8個、英數16個）
    if (length <= 16) {
      setBearName(input);
    } else {
      alert(t("bearSelection.nameAlert"));
    }
  };

  const updateStatusHandler = async () => {
    if (selected === null) {
      alert(t("bearSelection.alert"));
      return;
    }
    setShowModal(false);

    const success = await dispatch(
      updateStatus({
        ...statusData,
        user_name: bearName,
        bear_type: selected + 1,
      }),
    );

    if (success) {
      setIsAnimation(true);
      setTimeout(() => {
        setIsPlaying(true);
      }, 1000);
      setTimeout(() => {
        navigate("/myBear");
      }, 3500);
    } else {
      console.error("Failed to update status");
    }
  };

  return (
    <article className={`bear-selection ${isAnimation ? "active" : ""}`}>
      <div className="bg"></div>
      <div className="ball"></div>
      <div className="main">
        <div className="title">
          <h1>{t("bearSelection.title")}</h1>
        </div>
        {/* <div className="remind">{t("bearSelection.remind")}</div> */}
        <div className="bear-box">
          {bear.map((item, index) => (
            <div
              className={`bear ${selected === index ? "selected" : ""}`}
              key={index}
              onClick={() => selectedHandler(index)}
            >
              {/* <figure>
                <img src={item.bear} alt="" />
              </figure> */}
              <div className="bear-image">
                <ImageSlider
                  images={item.bear}
                  isPlaying={isPlaying}
                  loop={false}
                />
              </div>
              <figure className="bear-hover">
                <img src={BearHover} alt="" />
              </figure>
            </div>
          ))}
        </div>
        <input
          type="text"
          value={bearName}
          placeholder={t("bearSelection.placeholder")}
          onChange={handleChange}
        />
        <div
          className={`btn-box ${
            selected === null || bearName === "" ? "disable" : ""
          }`}
          onClick={() => setShowModal(true)}
        >
          <div className="btn-txt">
            {t("bearSelection.btnTxt")}
            {bearName !== "" && selected !== null ? (
              <figure className="btn-arrow">
                <img src={btnArrow} alt="" />
              </figure>
            ) : (
              <figure className="btn-arrow">
                <img src={btnArrowDisable} alt="" />
              </figure>
            )}
          </div>
          {bearName !== "" && selected !== null ? (
            <figure className="btn">
              <img src={btn} alt="" />
            </figure>
          ) : (
            <figure className="btn-disable">
              <img src={btnDisable} alt="" />
            </figure>
          )}
        </div>
      </div>
      {showModal ? (
        <div className="modal">
          <div className="wrapper">
            <div className="modal-content">
              <div className="bear">
                <div className="bear-image">
                  <img src={bearList[selected]} alt="" />
                </div>
                <div className="bear-name">{bearName}</div>
              </div>
              <div className="content">
                <p
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(t("bearSelection.modalTxt")),
                  }}
                ></p>
                <div className="btn-box">
                  <div className="btn" onClick={() => setShowModal(false)}>
                    <div className="btn-txt">
                      {t("bearSelection.modalBtnBack")}
                    </div>
                    <BtnSVG />
                  </div>
                  <div className="btn" onClick={() => updateStatusHandler()}>
                    <div className="btn-txt">
                      {t("bearSelection.modalBtnCheck")}
                    </div>
                    <BtnSVG />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </article>
  );
}
